<template>
  <span class="divider" v-bind:class="{ 'divider--dark': dark }"></span>
</template>

<script>
export default {
  props: { dark: Boolean },
};
</script>

<style lang="scss">
@import "../styles/components/_divider.scss";
</style>
